var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 11C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9V11ZM2.29289 9.29289C1.90237 9.68342 1.90237 10.3166 2.29289 10.7071L8.65685 17.0711C9.04738 17.4616 9.68054 17.4616 10.0711 17.0711C10.4616 16.6805 10.4616 16.0474 10.0711 15.6569L4.41421 10L10.0711 4.34315C10.4616 3.95262 10.4616 3.31946 10.0711 2.92893C9.68054 2.53841 9.04738 2.53841 8.65685 2.92893L2.29289 9.29289ZM17 9L3 9V11L17 11V9Z",
    fill: "#2B2526"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.3ff7152dd61a6c583a3807c9ec01fcd8.svg";
export { ForwardRef as ReactComponent };